import { addDays } from 'date-fns';
import { atom, useAtom, useAtomValue } from 'jotai';
import { apiConfigAtom } from '../api/accountActivity';
import { accountSummaryAtom } from '../api/accountSummary';
import { paymentMethodsAtom } from '../api/paymentMethods';
import { settlementEligibilityAtom } from '../api/settlementEligibility';
import { MakeAPaymentView, useCurrentViewAtom } from './currentViewAtom';
export const multiPaymentAtom = atom([]);
export const showCloseInterstitialAtom = atom(false);
const isErrorViewAtom = atom(false);
export const useIsErrorView = () => useAtom(isErrorViewAtom);
export const useShowCloseInterstitial = () => useAtom(showCloseInterstitialAtom);
export const multiPaymentQueryAtoms = atom((get) => ({
    apiConfig: get(apiConfigAtom),
    accountSummaryQueryResult: get(accountSummaryAtom),
    paymentMethodsQueryResult: get(paymentMethodsAtom),
    settlementEligibilityQueryResult: get(settlementEligibilityAtom)
}));
export const useMultiPaymentQueryAtoms = () => {
    return useAtomValue(multiPaymentQueryAtoms);
};
export const getMultiPaymentDate = (index) => addDays(new Date(), 30 * index);
export const multiPaymentStateAtom = atom({});
export const useMultiPaymentReset = () => {
    const [, setMultiPaymentState] = useAtom(multiPaymentStateAtom);
    const [, currentViewReducer] = useCurrentViewAtom();
    return () => {
        setMultiPaymentState({});
        currentViewReducer({
            type: 'updateView',
            view: MakeAPaymentView.MultiPaymentDetails
        });
    };
};
